import React from 'react';
import { connect } from 'react-redux';
import './Footer.scss';
import { RootState } from '../../models/RootState';
import Copyright from '../Copyright/Copyright';
import PaymentView from '../Copyright/PaymentView';
import './Footer.scss';
type StoreProps = {
  allowedConfig: number;
};

const Footer: React.FC<StoreProps> = (props) => {
  const { allowedConfig } = props;
  return (
    <>
      <PaymentView />
      <div className="footer-ctn">
        <Copyright></Copyright>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    allowedConfig: state.common.allowedConfig,
  };
};

export default connect(mapStateToProps, null)(Footer);
